/* ==========================================================
   Bags n Variety — Featured Products v2
   Minimal vanilla JS (no jQuery)
   Handles: wishlist toggle, quick add to cart
   Desktop-only controls — this script never runs on mobile
   since the buttons aren't rendered there in the CSS.
   ========================================================== */

(function () {
  'use strict';

  var WISHLIST_KEY = 'bnv_wishlist';

  /* ---------------- Wishlist (localStorage) ---------------- */

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable — fail silently */
    }
  }

  function toggleWishlist(button) {
    var productId = button.getAttribute('data-product-id');
    var list = getWishlist();
    var index = list.indexOf(productId);

    if (index > -1) {
      list.splice(index, 1);
      button.classList.remove('is-active');
    } else {
      list.push(productId);
      button.classList.add('is-active');
    }
    saveWishlist(list);

    document.dispatchEvent(
      new CustomEvent('bnv:wishlist:updated', { detail: { wishlist: list } })
    );
  }

  function initWishlistState() {
    var list = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      if (list.indexOf(id) > -1) {
        btn.classList.add('is-active');
      }
    });
  }

  /* ---------------- Quick Add to Cart ---------------- */

  function quickAdd(button) {
    var variantId = button.getAttribute('data-variant-id');
    var requiresVariants = button.getAttribute('data-requires-variants') === 'true';
    var productUrl = button.getAttribute('data-product-url');

    if (!variantId || requiresVariants) {
      // Multiple variants — send the shopper to the product page
      // to choose options rather than guessing one.
      if (productUrl) window.location.href = productUrl;
      return;
    }

    button.disabled = true;
    button.classList.add('is-loading');

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(function () {
        button.classList.remove('is-loading');
        button.classList.add('is-added');
        document.dispatchEvent(new CustomEvent('cart:updated'));
        setTimeout(function () {
          button.classList.remove('is-added');
          button.disabled = false;
        }, 1800);
      })
      .catch(function () {
        button.classList.remove('is-loading');
        button.disabled = false;
      });
  }

  /* ---------------- Event delegation ---------------- */

  document.addEventListener('click', function (e) {
    var wishlistBtn = e.target.closest('[data-wishlist-toggle]');
    if (wishlistBtn) {
      e.preventDefault();
      toggleWishlist(wishlistBtn);
      return;
    }

    var quickAddBtn = e.target.closest('[data-quick-add]');
    if (quickAddBtn) {
      e.preventDefault();
      quickAdd(quickAddBtn);
      return;
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistState);
  } else {
    initWishlistState();
  }
})();
